import { env } from '@/core/env';

/** Sales + scheduling URLs for the Enterprise contact flow. */
export const BILLING_SALES_EMAIL = env.VITE_SALES_EMAIL ?? 'sales@up2promo.com';

export const BILLING_CALENDLY_URL =
  env.VITE_CALENDLY_URL ?? 'https://calendly.com/up2promo/enterprise';
